<template>
    <b-navbar-brand href="#" class="d-flex" style="font-size:1.9em"
        :active="true" 
        :disabled="$route.path == '/login' || $route.path == '/register'"
        @click="$route.path != '/' ? $router.push('/') : null"
    >
        
        <img src="../assets/logos/mfz-logo.png" 
            class="d-sm-none align-self-center" 
            style="filter:invert(1);height:1em" 
        />
        <img src="../assets/logos/mitfahrzentrale-logo.png" 
            class="d-none d-sm-block align-self-center" 
            style="filter:invert(1);height:1em" 
        />
    </b-navbar-brand>
</template>

<script>
import { BNavbarBrand } from "bootstrap-vue"

export default {
    name: "NavBrand",
    components:{
        BNavbarBrand
    }
}
</script>